define('components/click-and-reveal-author/models/hotspot-manager',[
    "components/click-and-reveal-author/models/base-hotspot"
], function(BaseHotspotModel) {
    "use strict";

    /** =========================  hotspot Manager ========================= **/
    /**
     * classes in Hotspot component
     * @module HotspotManager model
     **/
    var HotspotManager = Backbone.Model.extend({
        "defaults": function() {
            return {
                /**
                 * Contain manager mode, depending upon mode Hotspot manager will decide hotspot action (create, display etc..)
                 *
                 * @property mode
                 * @type String
                 * @public
                 * @default MANAGER_MODE.MANAGER_MODE.EDIT
                 **/
                "mode": HotspotManager.MANAGER_MODE.EDIT,

                /**
                 * Contain data related to hotspots rendering.
                 *
                 * @property hotspots
                 * @type Array
                 * @public
                 **/
                "hotspots": [],
                "validatationTextArray": []

            };
        }
    }, {
        /**
         * Hotspot manager mode's enum,
         * different mode are as follows:
         *     MANAGER_MODE.CREATE: for creating hotspots.
         *     MANAGER_MODE.EDIT: for editing already created hotspots.
         *     MANAGER_MODE.DISPLAY: for displaying already created hotspots.
         *
         * @property MANAGER_MODE
         * @type Object
         * @static
         * @public
         **/
        "MANAGER_MODE": BaseHotspotModel.MANAGER_MODE,

        /**
         * Hotspot type's enum,
         * Different hotspot type's are as follows:
         *       HOTSPOT_TYPE.POINT: Point hotspot type
         *       HOTSPOT_TYPE.TEXT: Text hotspot type
         *       HOTSPOT_TYPE.IMAGE: Image hotspot
         *
         * @property HOTSPOT_TYPE
         * @type Object
         * @static
         * @public
         **/
        "HOTSPOT_TYPE": BaseHotspotModel.HOTSPOT_TYPE,

        /**
         * Padding between hotspot
         * @type {Object}
         * @static
         * @public
         **/
        "PADDING": 20

    });
    return HotspotManager;
});

